class Statistics {
    constructor() {
        // Statistics block + stats in the image-text block
        this.selector = '.statistics, .image-text .stats';
        this.initCounters();
    }

    initCounters() {
        if (!document.querySelector(this.selector)) {
            return;
        }

        // Hide the numbers up front so they can fade in while counting
        document.querySelectorAll(this.selector).forEach((element) => {
            gsap.set(element.querySelectorAll('.stat .is-number .value'), { opacity: 0 });
        });

        ScrollTrigger.batch(this.selector, {
            // markers: true,
            once: true,
            onEnter: (elements) => {
                elements.forEach((element) => {
                    const items = element.querySelectorAll('.stat .is-number .value');
                    if (!items.length) {
                        element.classList.add('completed');
                        return;
                    }

                    // Lock the width at the final value so surrounding content doesn't shift while counting
                    items.forEach((item) => {
                        item.style.minWidth = `${item.getBoundingClientRect().width}px`;
                    });

                    // Fade in slowly so the first counted numbers are faint and get clearer towards the end
                    gsap.to(items, {
                        opacity: 1,
                        duration: 0.7,
                        ease: 'power2.in'
                    });

                    gsap.from(items, {
                        textContent: 0,
                        duration: 3,
                        ease: 'Power1.easeInOut',
                        snap: { textContent: 1 },
                        stagger: {
                            each: 0,
                            onUpdate: function () {
                                this.targets()[0].innerHTML = Math.ceil(this.targets()[0].textContent);
                            }
                        },

                        onComplete: () => {
                            items.forEach((item) => (item.style.minWidth = ''));
                            element.classList.add('completed');
                        }
                    });
                });
            },
            start: 'top 80%',
            end: 'bottom top'
        });
    }
}
new Statistics();
